if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggleWrapper = this.querySelector('.mobile-toggle-wrapper');
      this.toggleButton = this.querySelector('.mobile-toggle');
      setTimeout(() => this.focusTrap = new FocusTrap(), 300);

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      // Mobile toggle button clicked
      this.toggleButton.addEventListener('click', (e) => {
        if (this.toggleWrapper.classList.contains('active')) {
          // Opened, so close it
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggleWrapper.classList.remove('active');
          this.toggleButton.ariaExpanded = false;
          this.toggleButton.focus();
          this.closeAnimation(this.toggleWrapper);
          window.dispatchEvent(new Event('scroll'));
          if (this.focusTrap.abortEscKeyListener) {
            this.focusTrap.abortEscKeyListener.abort();
          }
        } else {
          // Closed, so open it
          e.preventDefault();
          this.classList.add('is-sticky');
          document.body.classList.add('overflow-hidden');
          this.toggleWrapper.classList.add('active');
          this.toggleButton.ariaExpanded = true;

          // Trap focus and handle escape key
          this.focusTrap.listenForEscape(() => {
            document.body.classList.remove('overflow-hidden');
            this.toggleWrapper.classList.remove('active');
            this.toggleButton.ariaExpanded = false;
            this.toggleButton.focus();
            this.closeAnimation(this.toggleWrapper);
            window.dispatchEvent(new Event('scroll'));
          });
          this.focusTrap.trapFocus(this);
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        document.querySelector('.product-information')?.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      if (isOpen) {
        // event.preventDefault();
        // detailsElement.classList.add('menu-closing');
        // setTimeout(() => {
        //   detailsElement.removeAttribute('open');
        //   detailsElement.classList.remove('menu-closing');
        // }, 300);
        return;
      }
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      detailsElement.classList.add('menu-opening');
      setTimeout(() => {
        detailsElement.classList.remove('menu-opening');
      }, 300);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}